<style lang="scss" scoped>
.transfer-com {
    margin-top: 15px;
    margin-left: 10px;
    width: 100%;
}
.kuang-container {
    position: relative;
}
</style>
<template>
	<div class="clearfix">
		<compWrapper class="kuang-container pull-left width-45per" title="权限菜单" theme="primary">
            <Spin fix v-if="childLoading"></Spin>
			<!-- <vTree
				style="overflow: auto;height: 320px;"
				@on-check-change="getResourceIds"
				:data="dataList"
				selection
				class="padding-10"
			></vTree> -->
            <Transfer
                class="transfer-com"
                :data="dataList"
                :target-keys="resourceIds"
                :render-format="renderFormat"
                @on-change="changeItem"
                ></Transfer>
		</compWrapper>
		<compWrapper class="pull-right width-45per" title="基本信息" theme="primary">
			<compFormEdit :formdata="getBase" v-model="formData" ref="form" class="margin-15"></compFormEdit>
		</compWrapper>
		<footer class="pull-right text-right width-100per">
			<vButton theme="primary" class="margin-right-15" @click="submit">确认</vButton>
			<vButton @click="cancel">取消</vButton>
		</footer>
		<vLoading loading size="large" fix v-if="loading"></vLoading>
	</div>
</template>

<script>
import { HttpUpdateAccessGroup, HttpAccessGroup, HttpAccessGroupAlias, HttpBiReportSqlList } from '@/service/ucadm';
import { mapGetters, mapState } from 'vuex';
export default {
	props: ['params'],
	data() {
		return {
			resourceIds: [],
			checkIds: [],
			formData: {
				name: "",
				isGlobal: 0,
			},
            loading: false,
            childLoading: true,
			dataList: []
		};
	},
	mounted() {
		this.getDetail();
	},
	computed: {
		...mapState(['userinfo']),
		isSuper() {
			return this.userinfo.isOps == 1 || this.userinfo.isSuper == 1;
		},
		isAdd() {
			return this.params.type === 'add'
		},
		getBase() {
			return [{
				label: '名称',
				key: 'displayName',
				span: 24,
			}, {
				label: '标识符:',
				key: 'name',
				span: 24,
				required: false,
				on: {
					'on-focus': this.convertNameAlias
				},
            }, 
            // {
			// 	label: '是否全局角色',
			// 	tag: "vCheckBox",
			// 	span: 24,
			// 	key: 'isGlobal',
			// 	required: false,
			// 	props: {
			// 		trueValue: 1,
			// 		falseValue: 0,
			// 		readonly: !this.isAdd,
			// 	},
			// 	show: !(!this.isSuper && this.isAdd)
            // }, 
            {
				label: '描述',
				tag: "vTextarea",
				required: false,
				span: 24,
				key: 'description'
			}]
		},
	},
	methods: {
        renderFormat (item) {
            return item.label
        },
        changeItem (item) {
            this.resourceIds = item
        },
		cancel() {
			this.$emit('on-close');
		},
		getResourceIds(val, node, checked, indeterminate) {
			this.resourceIds = [...checked, ...indeterminate];
			console.log(this.resourceIds)
		},
		async submit() {
            if (this.childLoading) return this.$VMessage.error('请等待数据加载完成再保存')
			let vaild = await this.$refs.form.validate();
			if (!vaild) return;
			this.loading = true;
			let formData = { ...this.formData, module: 'DataReport', resourceIds: this.resourceIds.join(',') };
			if (this.params.type === 'edit') {
				formData.id = this.params.id;
			}
			let response = await HttpUpdateAccessGroup(formData).catch(err => {
				this.$VMessage.error(err.message);
			});
			this.loading = false
			if (response) {
				this.$VMessage.success(response.message);
				this.$emit('on-close');
				this.$emit('on-update');
			}
		},
		async getDetail() {
			this.loading = true;
			if (this.params.type !== 'edit') {
				await this.getDataReportList().catch(err => {
					this.$VMessage.error(err.message);
				});
				this.loading = false;
				return;
			};
			const response = await HttpAccessGroup({ id: this.params.id }).catch(err => {
				this.$VMessage.error(err.message);
			});
			if (response) {
				const { displayName, name, description } = response.data.entity || {};
				const isGlobal = response.data.isGlobal ? 1 : 0;
				this.formData = { displayName, name, description, isGlobal };
				this.checkIds = this.resourceIds = response.data.resourceIds || [];
			}
			await this.getDataReportList().catch(err => {
				this.$VMessage.error(err.message);
			});
			this.loading = false;
		},
		async convertNameAlias() {
			let displayName = this.formData.displayName
			if (!displayName || this.formData.name) return;
			let response = await HttpAccessGroupAlias({ displayName }).catch(err => {
				this.$VMessage.error(err.message);
			});
			if (response) {
				this.formData.name = response.data;
			}
		},
		//数据备选
		async getDataReportList() {
			await HttpBiReportSqlList().then(res => {
				const ids = this.checkIds || [];
				this.dataList = (res.data || []).map((item) => {
					return {
						label: item.title,
						key: item.id
					}
                });
			}).catch(err => {
				this.$VMessage.error(err.message);
			});
            this.childLoading = false
		},
	},
};
</script>
